module.exports = __webpack_public_path__ + "img/gp_promotion_male_2.d71aa5d5.png";